import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  ViewChildren,
  QueryList,
  OnDestroy,
} from '@angular/core';
import { PartInfo } from 'src/app/models/partinfo';
import { ProposalService } from 'src/app/services/proposal.service';
import { DatePipe } from '@angular/common';
import { Observable, of } from 'rxjs';
import {
  GridData,
  DataStateChangeEvent,
  Sort,
} from '@tesla/angular2-tesla-common/grid/grid.models';
import Helper from 'src/app/core/utility/helper';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { PendingProposalPartInfo } from 'src/app/models/internal/pendingproposalpartinfo';
import { TeslaGridComponent } from '@tesla/angular2-tesla-common/tesla-common';
import { tap, filter, partition } from 'rxjs/operators';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { Constants } from 'src/app/core/constants';
import { QueryPendingProposalDTO } from 'src/app/models/internal/query-pendingproposal-dto';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { CopyProposalDTO } from 'src/app/models/internal/copy-proposal-dto';
import { ValidateEffectivityFrom } from 'src/app/commonUI/customValidators/proposaliinfofields.valdiator';
import { CopyFromProposalDTO } from 'src/app/models/internal/copyfrom-proposal-dto';
import { CopyfromProposalListComponent } from '../copyfrom-proposal-list/copyfrom-proposal-list.component';
import { routerNgProbeToken } from '@angular/router/src/router_module';
import { ProposalBasicInfoDTO } from 'src/app/models/internal/proposal-basicInfo-dto';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';

@Component({
  selector: 'app-saved-proposals',
  templateUrl: './saved-proposals.component.html',
  styleUrls: ['./saved-proposals.component.scss']
})
export class SavedProposalsComponent extends BaseGridPage implements OnInit, AfterViewInit{
  savedProposalList: ProposalBasicInfoDTO[];
  ids: number[] = [];
  isInboundShipment: boolean = true;
  locStorage = Constants.localStorageKeys;
  pipe = new DatePipe('en-US');

  constructor(
      private dataService: DataService,
      private fb: FormBuilder,
      private proposalService: ProposalService,
      localstorageService: LocalstorageService,
      private toastService: ToastService,
      private formService: FormService,
      logger: NGXLogger,
      appSettings: AppSettings,
        private router: Router
  ) {
      super(localstorageService, logger, appSettings);
  }

  ngOnInit() {
      this.proposalService.savedproposalIds.subscribe(ids => {
        if (ids) {
          this.ids = ids;
        }
      });
      this.initFilterValues();
      this.fillGrid();
  }


  fillGrid(): void {
      this.filter.Skip = this.skip;
      this.filter.Take = this.pageSize;
      this.getProposals();
  }

  initFilterValues(): void {
      this.filter = new SearchFilter();
  }


  getProposals() {
      if (this.ids && this.ids.length > 0) {
      this.dataService
          .getProposalsByIds(this.ids)
          .subscribe((response: any) => {
              // this.partInfo = response
              if (response != null) {
                  this.savedProposalList = response.Data;
                  this.gridView = of({
                      data: response.Data,
                      total: response.Total ? response.Total : 0,
                  });
              }
          });
        } else {
          // this.toastService.error("No Proposal Ids to display");
       this.router.navigate(['../']);
        }
  }

  viewProposal(id: number) {
      this.proposalService.RefreshproposalToViewId(id);
      window.open('viewproposal/' + id, '_blank');
      // this.router.navigate(['../', 'pe-proposalsnapshot']).then(result => {  window.open(['../', 'pe-proposalsnapshot'], '_blank'); });
      // this.router.navigate(['../', 'pe-proposalsnapshot']);
  }

  navigateToUpdateProposal(id: number) {
      this.router.navigate(['/proposal', id] );
      // window.open('/proposal/' + id);

  }
  goToHome() {
    this.router.navigate(['/']);
  }

getEffectivityFrom(dataItem: any) {
  if (dataItem) {
  const effectivityFrom = this.pipe.transform(dataItem.EffectiveFrom, 'shortDate');
  return effectivityFrom;
  } else {
    return '';
  }
}
}
